import React from 'react'
import { create } from 'react-modal-promise'
import { ModalBig } from '@/modules/base/components/modal'

const AwaitableModal = (props) => {
  const {
    isOpen,
    onResolve,
    onReject,
    width,
    showCloseIcon = true,
    cancelReject = false,
    // Passed through to ModalBig - undefined keeps the dismissible behaviour of existing callers.
    disableEscapeKeyDown,
    disableBackdropClick,
    onClose = () => {},
    onCancel = () => {},
    component: ModalComponent,
    ...otherProps
  } = props

  const handleReject = () => {
    onCancel()
    cancelReject ? onReject() : onResolve(false)
  }

  // The payload lets a modal hand its result back instead of mutating the model it was given.
  const handleResolve = (payload) => {
    onClose(payload)
    onResolve(payload)
  }

  return (
    <ModalBig
      open={isOpen}
      onClose={handleReject }
      showCloseIcon={showCloseIcon}
      disableEscapeKeyDown={disableEscapeKeyDown}
      disableBackdropClick={disableBackdropClick}
      width={width}
    >
      <ModalComponent {...otherProps} onReject={handleReject} onResolve={handleResolve} />
    </ModalBig>

  )
}

export const awaitableModal = create(AwaitableModal)
